import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import { queryKeys } from "@/queryKeys";

export interface BorrowerTransaction {
  id: number;
  date: string;
  description: string;
  amount: number;
  balance?: number;
  transaction_type: "credit" | "debit";
  category?: string;
  account_name?: string;
  account_number?: string;
  memo?: string;
  tags_display?: string;
  tag_metadata?: Record<string, string>;
  counterparty_name?: string;
  /**
   * Funder name after cross-statement canonicalization (Claude runs only).
   * Funder cards are grouped by this, so funder filters should prefer it over
   * the raw `counterparty_name`.
   */
  canonical_counterparty_name?: string;
  is_mca_payment?: boolean;
  is_revenue?: boolean;
  is_nsf?: boolean;
  /** Content key for AnalysisOverride posts (Claude-materialized rows). */
  override_key?: string | null;
}

export function useBorrowerTransactionsQuery(
  borrowerId: number | string | null,
  source: "statements" | "plaid" = "statements"
) {
  const id = borrowerId != null ? Number(borrowerId) : null;
  return useQuery({
    queryKey: queryKeys.borrowerTransactions(id, source),
    queryFn: async () => {
      const response = await api.get<{ transactions?: BorrowerTransaction[] }>(
        "/transactions/transactions/filtered/",
        {
          params: { borrower_id: id, per_page: 10000, source },
        }
      );
      return response.data.transactions ?? [];
    },
    enabled: id != null,
  });
}
